import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export type EmailOutboxStatus = 'pending' | 'sent' | 'failed';

export interface EmailOutboxListFilter {
  status?: EmailOutboxStatus[];
  eventType?: string[];
  startDate?: string;
  endDate?: string;
  recipientEmail?: string;
  page?: number;
  limit?: number;
}

export interface EmailOutboxEntry {
  id: number;
  parent_id: number | null;
  event_type: string;
  recipient_email: string;
  recipient_name: string | null;
  subject: string;
  rendered_body: string;
  status: EmailOutboxStatus;
  attempt_count: number;
  last_attempted_at: string | null;
  error_message: string | null;
  attachment_path: string | null;
  created_at: string;
}

const buildQuery = (filter: EmailOutboxListFilter) => {
  const params: Record<string, string> = {};
  if (filter.status?.length) params.status = filter.status.join(',');
  if (filter.eventType?.length) params.eventType = filter.eventType.join(',');
  if (filter.startDate) params.startDate = filter.startDate;
  if (filter.endDate) params.endDate = filter.endDate;
  if (filter.recipientEmail) params.recipientEmail = filter.recipientEmail;
  if (filter.page) params.page = String(filter.page);
  if (filter.limit) params.limit = String(filter.limit);
  const qs = new URLSearchParams(params).toString();
  return qs ? `?${qs}` : '';
};

const listOutbox = (filter: EmailOutboxListFilter) => http.get(`${API_ENDPOINTS.notificationsOutbox}${buildQuery(filter)}`);

const retryOutbox = (id: number | string) => http.post(`${API_ENDPOINTS.notificationsOutbox}/${id}/retry`);

const NotificationService = { listOutbox, retryOutbox };

export default NotificationService;
